/*
 * Accessibility fixes for 3rd-party app blocks that don't expose ARIA.
 * Source: Lighthouse PSI audit (mobile + desktop) — 2026-04-27
 *
 * Why this is JS, not CSS: aria-label / alt cannot be set via stylesheets.
 * We use a MutationObserver because judge.me renders its widgets after
 * DOMContentLoaded, so we can't just query once on load.
 */
(function () {
  'use strict';

  function fixJudgeMeAriaLabels(root) {
    // judge.me carousel arrows render as <button class="jdgm-arrow"> with
    // no accessible name. Add aria-label based on the onclick handler name.
    var arrows = root.querySelectorAll('button.jdgm-arrow:not([aria-label])');
    arrows.forEach(function (btn) {
      var onclick = btn.getAttribute('onclick') || '';
      if (onclick.indexOf('Previous') !== -1) {
        btn.setAttribute('aria-label', 'Previous review');
      } else if (onclick.indexOf('Next') !== -1) {
        btn.setAttribute('aria-label', 'Next review');
      } else {
        btn.setAttribute('aria-label', 'Review carousel control');
      }
    });

    // judge.me review images sometimes render without alt. Add a generic alt
    // so screen readers don't read the URL filename.
    var imgs = root.querySelectorAll('.jdgm img:not([alt]), img[src*="judgeme.imgix.net"]:not([alt]), img[src*="judge.me"]:not([alt])');
    imgs.forEach(function (img) {
      img.setAttribute('alt', 'Customer review photo');
    });
  }

  function init() {
    fixJudgeMeAriaLabels(document);
    // Re-check at fixed delays to catch judge.me's async widget rendering.
    // Cheaper than a permanent MutationObserver, which was running its
    // callback on every node added by 3rd-party scripts and inflating TBT.
    [500, 1500, 4000].forEach(function (ms) {
      setTimeout(function () { fixJudgeMeAriaLabels(document); }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
